import { createFileRoute } from "@tanstack/react-router";

import { ReferralsPage } from "../../../../areas/seller/more/referrals/ReferralsPage";

export const Route = createFileRoute("/app/_seller/more/referrals")({
  component: ReferralsPage,
});
